import React, { useState } from 'react';
import { MessageCircle, Copy, Search, Lock } from 'lucide-react';
import { listaInvitados } from './data/invitados'; // Asegúrate que la ruta sea correcta

const AdminPanel = () => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  // CAMBIA ESTA CONTRASEÑA POR LA QUE QUIERAS
  const SECRET_PASS = process.env.REACT_APP_PASSWORD_ADMIN;

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === SECRET_PASS) {
      setIsAuthenticated(true);
    } else {
      alert("Contraseña incorrecta");
    }
  };

  const generateLink = (id) => {
    // Obtiene el dominio actual (localhost o tu dominio real)
    const baseUrl = window.location.origin; 
    return `${baseUrl}/invitacion/${id}`;
  };

  const sendWhatsApp = (guest, id) => {
    if (!guest.telefono) {
      alert("Este invitado no tiene teléfono registrado en el JSON");
      return;
    }

    const link = generateLink(id);
    
    const textoLugares = guest.pases === 1 ? "un lugar" : `${guest.pases} lugares`;

// MENSAJE CON PSICOLOGÍA DE RESERVA:
    const mensaje = 
      `Hola ${guest.nombre} 👋, estamos preparando nuestra boda con mucho cariño y no nos imaginamos este día sin ustedes.\n\n` +
      `Hemos reservado ${textoLugares} especialmente para ustedes. 🤍\n\n` +
      `Aquí les dejo su invitación personalizada para que vean los detalles y nos ayuden a confirmar su asistencia: ${link}`;

    // Limpiamos el teléfono (quitamos espacios o guiones si los hubiera, aunque tu JSON ya tiene +52)
    const phone = guest.telefono.replace(/\s+/g, '');
    
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(mensaje)}`, '_blank');
  };

  const copyLink = (id) => {
    const link = generateLink(id);
    navigator.clipboard.writeText(link);
    alert("Link copiado al portapapeles: " + link);
  };

  // Convertimos el objeto de invitados a un array para poder filtrarlo
  const invitadosArray = Object.entries(listaInvitados).map(([key, value]) => ({
    id: key,
    ...value
  }));

  const filteredGuests = invitadosArray.filter(g => 
    g.nombre.toLowerCase().includes(searchTerm.toLowerCase()) || 
    g.host.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sumatoriaPases = filteredGuests.reduce((total, guest) => total + guest.pases, 0);

  if (!isAuthenticated) {
    return (
      <div style={styles.loginContainer}>
        <div style={styles.loginBox}>
          <Lock size={40} color="#C5A065" />
          <h2 style={{color: '#5A6E5A'}}>Admin Boda</h2>
          <form onSubmit={handleLogin} style={{display:'flex', flexDirection:'column', gap:'10px'}}>
            <input 
              type="password" 
              placeholder="Contraseña" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
            />
            <button type="submit" style={styles.btnPrimary}>Entrar</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1>Panel de Administración</h1>
        <div style={styles.searchBox}>
          <Search size={20} color="#666" />
          <input 
            type="text" 
            placeholder="Buscar invitado..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.searchInput}
          />
        </div>
      </div>

      <div className='total-invitados' style={{marginBottom:'10px'}}>
        <strong>Total Invitados: {sumatoriaPases}</strong>
      </div>

      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr style={styles.thRow}>
              <th style={styles.th}>Nombre</th>
              <th style={styles.th}>Host</th>
              <th style={styles.th}>Pases</th>
              <th style={styles.th}>Teléfono</th>
              <th style={styles.th}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredGuests.map((guest) => (
              <tr key={guest.id} style={styles.tr}>
                <td style={styles.td}>
                  <strong>{guest.nombre}</strong><br/>
                  <small style={{color:'#999'}}>ID: {guest.id}</small>
                </td>
                <td style={styles.td}>
                  <span style={guest.host === 'jaziel' ? styles.tagJaz : styles.tagCeli}>
                    {guest.host.toUpperCase()}
                  </span>
                </td>
                <td style={styles.td}>{guest.pases} ({guest.adultos}A / {guest.ninos}N)</td>
                <td style={styles.td}>{guest.telefono || <span style={{color:'red'}}>Sin cel</span>}</td>
                <td style={styles.tdActions}>
                  {guest.telefono && (
                    <button onClick={() => sendWhatsApp(guest, guest.id)} style={styles.btnWhatsapp} title="Enviar por WhatsApp">
                      <MessageCircle size={18} /> Enviar
                    </button>
                  )}
                  <button onClick={() => copyLink(guest.id)} style={styles.btnCopy} title="Copiar Link">
                    <Copy size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// Estilos rápidos en JS para no llenar tu App.css
const styles = {
  container: { padding: '20px', fontFamily: 'sans-serif', backgroundColor: '#f4f4f4', minHeight: '100vh' },
  loginContainer: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#eee' },
  loginBox: { padding: '40px', background: 'white', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', textAlign: 'center' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  input: { padding: '10px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '1rem' },
  searchInput: { padding: '10px', border: 'none', outline: 'none', width: '100%' },
  searchBox: { display: 'flex', alignItems: 'center', background: 'white', padding: '0 10px', borderRadius: '4px', border: '1px solid #ddd', width: '300px' },
  tableContainer: { overflowX: 'auto', background: 'white', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)' },
  table: { width: '100%', borderCollapse: 'collapse', minWidth: '600px' },
  thRow: { background: '#5A6E5A', color: 'white' },
  th: { padding: '15px', textAlign: 'left', fontSize: '0.9rem' },
  tr: { borderBottom: '1px solid #eee' },
  td: { padding: '15px', color: '#333' },
  tdActions: { padding: '15px', display: 'flex', gap: '10px' },
  tagJaz: { background: '#e3f2fd', color: '#1565c0', padding: '4px 8px', borderRadius: '12px', fontSize: '0.7rem', fontWeight: 'bold' },
  tagCeli: { background: '#fce4ec', color: '#c2185b', padding: '4px 8px', borderRadius: '12px', fontSize: '0.7rem', fontWeight: 'bold' },
  btnPrimary: { background: '#C5A065', color: 'white', border: 'none', padding: '10px', borderRadius: '4px', cursor: 'pointer', marginTop: '10px' },
  btnWhatsapp: { background: '#25D366', color: 'white', border: 'none', padding: '8px 12px', borderRadius: '4px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' },
  btnCopy: { background: '#ddd', color: '#333', border: 'none', padding: '8px', borderRadius: '4px', cursor: 'pointer' }
};

export default AdminPanel;